import { BoundedContent } from '@vp/swan';
import { getLanguageCode } from '@99designs/i18n';
import { EnabledLocale, LOCALE_CONFIG } from './locales';

export type TrustpilotWidgetProps = {
    locale: EnabledLocale;
    templateID?: string;
    styleHeight?: string;
    styleWidth?: string;
    tags?: string;
    stars?: string;
};

export type TrustpilotWidgetConfig = {
    businessUnitID: string;
    token: string;
    href: string;
};

const DEFAULT_TEMPLATE_ID = '539adbd6dec7e10e686debee';

export function TrustpilotWidget({
    locale = 'en-US',
    templateID = DEFAULT_TEMPLATE_ID,
    styleHeight = '500px',
    styleWidth = '100%',
    tags = 'DesignServices',
    stars = '1,2,3,4,5',
}: TrustpilotWidgetProps) {
    const config = LOCALE_CONFIG[locale];

    if (!config) {
        console.warn('TrustpilotWidget: No configuration found for locale', locale);
        return null;
    }

    const reviewLanguage = getLanguageCode(locale);

    return (
        <BoundedContent>
            <div
                data-testid="trustpilot-widget"
                className="trustpilot-widget"
                data-locale={locale}
                data-template-id={templateID}
                data-token={config.token}
                data-businessunit-id={config.businessUnitID}
                data-style-height={styleHeight}
                data-style-width={styleWidth}
                data-tags={tags}
                data-stars={stars}
                data-review-languages={reviewLanguage}
            >
                <a href={config.href} target="_blank" rel="noopener noreferrer">
                    Trustpilot
                </a>
            </div>
        </BoundedContent>
    );
}
